import { Breadcrumb, Drawer, Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import CustomButton from 'base/ui/components/Button';
import BoxContainer from 'base/ui/components/BoxContainer';
import { ProColumns, ProTable } from '@ant-design/pro-components';
// icons
import * as Icon from 'base/ui/components/Icons';
import CustomSelect from 'base/ui/components/CustomSelect';
import { optionsDate } from '../dataDump';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SYSTEM_TITLE } from 'utils/constants';
import CustomInputString from 'base/ui/components/Input/customInputString';

interface DataType {
  key: string;
  stt: number;
  nghiepvu: string;
  idMau: string;
  tenMau: string;
  formKS: string;
  updateBy: string;
  updateDate: string;
}

const dataSource = [
  {
    key: '1',
    stt: 1,
    nghiepvu: 'Bảo hành',
    idMau: '260846',
    tenMau: 'Đánh giá trải nghiệm dịch vụ bảo hành',
    formKS: '100002',
    updateBy: 'admin',
    updateDate: '17/06/2023 00:00',
  },
  {
    key: '2',
    stt: 2,
    nghiepvu: 'Ghé thăm',
    idMau: '260840',
    tenMau: 'GOANCUONG_Khảo sát hài lòng KH sau ghé thăm',
    formKS: '100003',
    updateBy: 'admin',
    updateDate: '17/06/2023 00:00',
  },
  {
    key: '3',
    stt: 3,
    nghiepvu: 'Xử lí khiếu nại',
    idMau: '258949',
    tenMau: 'Thông báo hoàn thành xử lý khiếu nại',
    formKS: 'Sử dụng form khảo sát Zalo',
    updateBy: 'admin',
    updateDate: '17/06/2023 00:00',
  },
  {
    key: '4',
    stt: 4,
    nghiepvu: 'Nhắc nhở bảo hành',
    idMau: '258951',
    tenMau: 'Thông báo nhắc nhở lịch bảo hành',
    formKS: 'Không có form khảo sát',
    updateBy: 'admin',
    updateDate: '17/06/2023 00:00',
  },
];

const createZaloTaskZNS = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.zalo-task') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const showDrawer = () => {
      setOpen(true);
    };
    const onClose = () => {
      setOpen(false);
    };

    const columns: ProColumns<DataType>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
      },
      {
        title: t('search-form.major'),
        dataIndex: 'nghiepvu',
        key: 'nghiepvu',
      },
      {
        title: t('zalo-notification.zns-id'),
        dataIndex: 'idMau',
        key: 'idMau',
      },
      {
        title: t('zalo-notification.zns-name'),
        dataIndex: 'tenMau',
        key: 'tenMau',
      },
      {
        title: t('zalo-notification.survey-name'),
        dataIndex: 'formKS',
        key: 'formKS',
      },
      {
        title: t('zalo-notification.updater'),
        dataIndex: 'updateBy',
        key: 'updateBy',
      },
      {
        title: t('zalo-notification.update-day'),
        dataIndex: 'updateDate',
        key: 'updateDate',
      },
      {
        title: t('zalo-notification.function'),
        dataIndex: 'chucnang',
        key: 'chucnang',
        onCell: () => {
          return {
            style: {
              textAlign: 'center',
            },
          };
        },
        render: (value, record) => {
          return (
            <div className="flex gap-2">
              {record.formKS !== 'Không có form khảo sát' && (
                <CustomButton size="small">{t('btn.view-survey')}</CustomButton>
              )}
              <CustomButton
                onClick={() => {
                  navigate('edit');
                }}
                type="primary"
                size="small"
              >
                {t('btn.edit')}
              </CustomButton>
            </div>
          );
        },
      },
    ];

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.zalo-task'),
          },
        ]}
        extras={
          <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
            <Icon.Filter className="!fill-primary" />
          </CustomButton>
        }
      >
        {/* Form search */}
        <BoxContainer fullHeight>
          <ProTable<DataType>
            size="small"
            key={'stt'}
            bordered
            className="[&_.ant-table-wrapper_.ant-table.ant-table-bordered_>.ant-table-container]:rounded-none"
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            dateFormatter="string"
            search={false}
          />
        </BoxContainer>
        <SearchBox onClose={onClose} open={open}>
          <SearchForm form={form}>
            <SearchItem label={t('search-form.zns-code')} name={'mauZNS'}>
              <CustomInputString />
            </SearchItem>
            <SearchItem label={t('search-form.major')} name={'nghiepvu'}>
              <CustomInputString />
            </SearchItem>
            <SearchItem label={t('search-form.create-date')} name={'ngaytao'}>
              <CustomSelect options={optionsDate} />
            </SearchItem>
            <SearchItem label={t('search-form.from')} name={'tungay'} start>
              <CustomInputString />
            </SearchItem>
            <SearchItem label={t('search-form.to')} name={'denngay'}>
              <CustomInputString />
            </SearchItem>
            {/* Nút tìm kiếm  */}
            <div className="col-span-4 sticky bottom-[-24px] py-2 bg-white w-full">
              <CustomButton htmlType="submit" className="my-auto" type="primary">
                {t('btn.search')}
              </CustomButton>
            </div>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createZaloTaskZNS;
